<template>
  <div class="container">
    <div class="card">
        <div> 
          <router-link to="/">
            <img alt="back" src="../assets/back-primary.svg" class="card-img"/>
          </router-link>
          <span class="card-title">
              Login
          </span>
        </div> 
        <b-form @submit="submit" class="input">
          <b-form-input
            id="username"
            v-model="username"
            type="text"
            required
            placeholder="Nome utente"
          ></b-form-input>
          <b-form-input
            id="password"
            v-model="password"
            type="password"
            required
            placeholder="Password"
          ></b-form-input>
          <div class="button">
            <b-button block type="submit" variant="success">Accedi</b-button>
          </div>
        </b-form>
        <div class="signup" >
          <span @click="signup">
            Non hai un account? 
            <br />
            Richiedi l'accesso cliccando qui.
          </span>
        </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "LoginStudioForm",
  data () {
    return {
      password: "",
      username: ""
    }
  },
  methods: {
    signup: function(){
        this.$emit('signup');
    },
    isStudioGroup: function(userGroup){
      let authorizedUsers=['dottori', 'admin', 'gestori']
      let status = false;
      userGroup.forEach(element => {
        if(authorizedUsers.includes(element)){
          status = true;
          return;
        }
      });
      return status;
    },
    loginUser: function(path, userObj, token) {
      localStorage.setItem('access_token', token);
      console.log(userObj.data.group);
      let user = {
        'full_name': userObj.data.fullname,
        'user_type': userObj.data.group,
        'is_verified': userObj.data.verified
      }
      this.$store.dispatch("setUser", user);
      window.dispatchEvent(new CustomEvent('setUsername'));
      this.$router.push("/" + path)
    },
    submit: function(evt){
      evt.preventDefault();
      this.$axios.post( this.$apibase + '/auth/obtain_token/', {        
          'username': this.username,
          'password': this.password,
      })
      .then((response) => {
            this.$axios
            .get(this.$apibase + '/api/users/is_user_studio/', {
                headers: {
                    Authorization:"JWT " + response.data.token
                }
            })
            .then((verified) => {
                if (this.isStudioGroup(verified.data.group)){
                  this.loginUser('dashboard', verified, response.data.token);
                }
                else if (verified.data.group.includes('labs')) {
                  this.$store.dispatch('setAlert', {message: "Non hai accesso a questa parte del sito.", type: 'danger'});
                }
                else if(!verified.data.verified) {
                  this.loginUser('nuovo-utente', verified, response.data.token);
                }
            })
            .catch(() => {
              this.$store.dispatch('setAlert', {message: "La combinazione di username e password è incorretta.", type: 'danger'});
            })
        }
      )
      .catch(() => {
        this.$store.dispatch('setAlert', {message: "La combinazione di username e password è incorretta.", type: 'danger'});
      })
    }
  }
};
</script>

<style scoped>
  .container {
    text-align: center;
    padding-top: 100px;
  }
  .card{    
    width: 400px;
    display: inline-flex;
    height: 390px;
    box-shadow: 0 0 5px #6abf61;
    padding: 80px 50px;
    text-align: center;
    align-items: center;    
  }
  .card-title{
    font-size: 21px;
    font-weight: bold;
    float: left;
    padding-left: 10px;
  }
  .card-img{
    width:30px;
    float: left;
  }
  .input{
    padding-top: 40px;
    width: 100%;
  }
  .button {
    padding-top: 20px;
    width: 100%;
  }
  .signup{
    padding-top:20px;
    font-size: small;
    cursor: pointer;
  }
</style>